import * as React from "react";
import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import { FallbackIssuerIcon } from "./IssuerInfo/IssuerInfo";
import Image from "./Image";
import getLogoV3ImgSrc from "../utils/getLogoV3ImgSrc";
import isAAAIssuer from "../utils/isAAAIssuer";
import { useState } from "react";
export function isValidLogo(id) {
    return ![
        AllIssuers.PROGRESSIVE,
        AllIssuers.TRAVELERS,
        AllIssuers.STATE_FARM,
        AllIssuers.NATIONWIDE,
        AllIssuers.THE_HARTFORD,
    ].includes(id);
}
export function ConnectIssuerIcon(_a) {
    var fallback = _a.fallback, _b = _a.issuerId, issuerId = _b === void 0 ? "" : _b, className = _a.className, size = _a.size, altText = _a.altText, insuranceType = _a.insuranceType;
    var _c = useState(false), imageError = _c[0], setImageError = _c[1];
    var iconSrc = getLogoV3ImgSrc(issuerId, insuranceType);
    var canShowLogo = !fallback && !imageError && iconSrc && isValidLogo(issuerId);
    return canShowLogo ? (React.createElement(Image, { src: iconSrc, alt: altText || "".concat(issuerId, " icon"), width: 48, height: 48, onError: function () { return setImageError(true); }, "data-cy": "issuer-logo", className: className })) : (React.createElement(FallbackIssuerIcon, { id: issuerId, size: size }));
}
export function SavvyIssuerIcon(_a) {
    var fallback = _a.fallback, _b = _a.issuerId, issuerId = _b === void 0 ? "" : _b, className = _a.className, size = _a.size, altText = _a.altText, insuranceType = _a.insuranceType;
    var _c = useState(false), imageError = _c[0], setImageError = _c[1];
    var cleanId = isAAAIssuer({ id: issuerId }) ? "aaa" : issuerId;
    var iconSrc = getLogoV3ImgSrc(cleanId, insuranceType);
    var canShowLogo = !fallback && !imageError && iconSrc;
    return canShowLogo ? (React.createElement(Image, { src: iconSrc, alt: altText || "".concat(cleanId, " icon"), width: 48, height: 48, onError: function () { return setImageError(true); }, "data-cy": "issuer-logo", className: className })) : (React.createElement(FallbackIssuerIcon, { id: issuerId, size: size }));
}
